/*=========================================================================================
  File Name: module-dictionary-mutations.js
  Description: Dictionary Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export const defaultDictionaryState = {
	ProvinceList: [],
	DistrictList: [],
	WardList: [],
	TaxAgencyList: [],
	AllTaxAgencyList: [],
	TreasuryList: [], //Danh sách kho bạc nhà nước
	TreasuryBankList: [], //Danh sách ngân hàng được kho bạc ủy nhiệm
	ChapterList: [], //Danh sách mã chương theo quy định
	EconomicsList: [], //Danh sách nội dung kinh tế
	BankList: [], //Danh sách ngân hàng phục vụ cho nộp thuế điện tử
	Month: [],
	Quarter: [],
	Stage: [],
	TimesTaxPaid: [],
	ShowServey: false,
	AdminProcedureList: [],
};

export default {
	...defaultDictionaryState
};
